import { useQuery } from '@tanstack/react-query';
import { SubscribeProductType } from '@/libs/type/interfaces/subscription.interface';
import { checkProductIsSubscribed, getSubscribedStores } from '../api/subscription';

export const useCheckProductIsSubscribed = (productType: SubscribeProductType, options: { enabled: boolean } = { enabled: false }) => {
  return useQuery<boolean, Error>({
    queryKey: ['checkProductIsSubscribed', productType],
    queryFn: () => checkProductIsSubscribed(productType),
    enabled: options.enabled
  });
};

export const useGetSubscribedStores = (productType: SubscribeProductType, storeIds: number[], options: { enabled: boolean } = { enabled: false }) => {
  return useQuery({
    queryKey: ['getSubscribedStores', productType, storeIds],
    queryFn: () => getSubscribedStores(productType, storeIds),
    enabled: options.enabled
  });
};
